import * as actionTypes from "../actionTypes";

export const initFetchPromptStatus = () => ({
  type: actionTypes.INIT_FETCH_PROMPT_STATUS,
});

export const fetchPromptStatus = () => ({
  type: actionTypes.FETCH_PROMPT_STATUS,
});

export const fetchPromptStatusSuccess = (payload) => ({
  type: actionTypes.FETCH_PROMPT_STATUS_SUCCESS,
  payload,
});

export const fetchPromptStatusError = () => ({
  type: actionTypes.FETCH_PROMPT_STATUS_ERROR,
});

export const dismissPrompt = () => ({
  type: actionTypes.DISMISS_PROMPT,
});

export const initLogPrompt = (payload) => ({
  type: actionTypes.INIT_LOG_PROMPT,
  payload,
});

export const markPromptShownLogged = () => ({
  type: actionTypes.MARK_PROMPT_SHOWN_LOGGED,
});

export const setPromptSaving = (isSaving) => ({
  type: actionTypes.SET_PROMPT_SAVING,
  payload: isSaving,
});

export const setPromptSaveError = (error) => ({
  type: actionTypes.SET_PROMPT_SAVE_ERROR,
  payload: error,
});

export const clearPromptSaveError = () => ({
  type: actionTypes.CLEAR_PROMPT_SAVE_ERROR,
});
